import React from "react";
import "../styles/Skills.css";

const Skills = () => {
  const technicalSkills = [
    { category: "Languages", items: ["C++", "Python", "JavaScript", "PHP"] },
    { category: "Frameworks", items: ["React.js", "FastAPI", "Firebase"] },
    { category: "Databases", items: ["PostgreSQL", "Sybase", "MySQL"] },
    { category: "AI / ML", items: ["Deep Learning", "NLP", "Botpress"] },
    { category: "Automation", items: ["n8n", "CrewAI", "MCP"] },
    { category: "Cloud / Tools", items: ["GCP", "Git", "REST APIs", "Arduino"] }
  ];

  const softSkills = ["Problem-solving", "Teamwork", "Leadership", "Adaptability"];

  return (
    <section className="skills-section">
      <div className="skills-container">
        <h2 className="skills-heading">Skills</h2>
        
        <div className="skills-category">
          <h3 className="category-heading">Technical Skills</h3>
          <div className="skills-grid">
            {technicalSkills.map((skillGroup, index) => (
              <div className="skill-group" key={index}>
                <h4 className="skill-group-title">{skillGroup.category}</h4>
                <div className="skill-items">
                  {skillGroup.items.map((skill, idx) => (
                    <span className="skill-item" key={idx}>{skill}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="skills-category">
          <h3 className="category-heading">Soft Skills</h3>
          <div className="soft-skills-grid">
            {softSkills.map((skill, index) => (
              <div className="soft-skill-item" key={index}>
                {skill}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;